export default __webpack_public_path__ + "static/media/chat-icon.b40c3621.svg";